import { api } from './client.js';

export const carsApi = {
  list: () => api('/cars'),
  get: (id) => api(`/cars/${id}`),
  create: (formData) => api('/cars', { method: 'POST', form: formData }),
  update: (id, formData) => api(`/cars/${id}`, { method: 'PATCH', form: formData }),
  remove: (id) => api(`/cars/${id}`, { method: 'DELETE' }),
  photoUrl: (id) => `/api/files/cars/${id}/photo`,
};
